var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0"},[_c('v-row',{staticClass:"pa-0 ma-0"},[(_vm.latitude && _vm.longitude)?_c('v-col',{staticClass:"pa-0 ma-0"},[_c('GmapMap',{style:(("width: " + _vm.width + "; height: " + _vm.height)),attrs:{"center":{lat: this.latitude, lng: this.longitude},"zoom":15,"options":{
          zoomControl: false,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: false
        }}},[_c('GmapMarker',{attrs:{"position":{lat: this.latitude, lng: this.longitude },"clickable":false,"draggable":false}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }